import React, { forwardRef } from 'react';
import clsx from 'clsx';
import './Input.css';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  fullWidth?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      error,
      helperText,
      leftIcon,
      rightIcon,
      fullWidth = false,
      className,
      id,
      ...props
    },
    ref
  ) => {
    const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;

    return (
      <div className={clsx('input-wrapper', { 'input-full-width': fullWidth })}>
        {label && (
          <label htmlFor={inputId} className="input-label">
            {label}
          </label>
        )}
        <div className={clsx('input-container', { 'input-error': error })}>
          {leftIcon && <div className="input-icon input-icon-left">{leftIcon}</div>}
          <input
            ref={ref}
            id={inputId}
            className={clsx(
              'input',
              {
                'input-with-left-icon': leftIcon,
                'input-with-right-icon': rightIcon,
              },
              className
            )}
            {...props}
          />
          {rightIcon && <div className="input-icon input-icon-right">{rightIcon}</div>}
        </div>
        {(error || helperText) && (
          <div className={clsx('input-helper', { 'input-helper-error': error })}>
            {error || helperText}
          </div>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
